import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticStyle:{"width":"100%","height":"100vh"}},[_c(VOverlay,{attrs:{"color":"iq_dark","value":_vm.globalLoader}},[_c(VProgressCircular,{attrs:{"indeterminate":"","size":"70","width":"7","color":"primary"}})],1),(_vm.iframeUrl !== null)?_c(VCardText,{staticStyle:{"width":"100%","height":"100vh"}},[(_vm.iframeUrl)?_c('iframe',{attrs:{"src":_vm.iframeUrl,"width":"100%","height":"100%","frameborder":"0","allowfullscreen":""}}):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }